import { Image, Notes, Head } from "mdx-deck";
import { CodeSurferColumns, Step } from "code-surfer";
import { vsDark as classTheme, nightOwl as hooksTheme } from "@code-surfer/themes";
import GreetingLoader from "../../../../../../src/greeting-loader";
import * as React from 'react';
export default {
  Image: Image,
  Notes: Notes,
  Head: Head,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  classTheme: classTheme,
  hooksTheme: hooksTheme,
  GreetingLoader: GreetingLoader,
  React: React
};